import React, { useEffect, useState } from 'react';
import { ProductFruits } from 'react-product-fruits';
import { getCurrentLang } from 'common/helpers/i18n';
import { communicationAuth, IAuthConnectedProps } from 'entities/Auth/Auth.communication';
import { EAcademyStatus } from 'entities/Academy/Academy.models';

const ProductFruitsLayoutComponent: React.FC<IAuthConnectedProps> = props => {
  const { authUser, authAcademy } = props;
  const { data, loading } = authAcademy;
  const status = data?.status;
  const isAcademyActive = !loading && status === EAcademyStatus.Active;
  const { id } = authUser.data || {};
  const [showGuide, setShowGuide] = useState(false);
  const lang = getCurrentLang();
  const isShowGuide = showGuide && isAcademyActive;

  useEffect(() => {
    if (id) {
      const isFirstLogin = localStorage.getItem(`isFirstLogin_${id}`);

      if (!isFirstLogin && isAcademyActive) {
        setShowGuide(true);
        localStorage.setItem(`isFirstLogin_${id}`, 'true');
      }
    }
  }, [id]);

  // console.log('ProductFruits work status:', isShowGuide, 'lang:', lang);
  return isShowGuide ? (
    <ProductFruits workspaceCode="8ZDel8FQukjyirV2" language={lang} user={{ username: id || '' }} debug={true} />
  ) : null;
};
export const ProductFruitsLayout = communicationAuth.injector(ProductFruitsLayoutComponent);
